import { useCallback, useState } from 'react';

import useApp from '../../hooks/useApp';
import api from '../../services/api';

function useFaturasDetails() {
  const { setLoading: setLoadingApp } = useApp();
  const [faturasDetails, setFaturasDetails] = useState([]);
  const [totalHours, setTotalHours] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [page, setPage] = useState(0);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [situation, setSituation] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [razaoSocial, setRazaoSocial] = useState('');
  const [tipo, setTipo] = useState('');

  const load = useCallback((params) => {
    (async () => {
      try {
        setLoading(true);
        setPage(params.page || page);
        const query = new URLSearchParams({
          page: params.page,
        });
        // /profissionalFaturasMensal/year/:year/month/:month/situation/:situacao/cnpj/:cnpj/razaoSocial/:razaoSocial/tipo/:tipo
        const { data = { docs: [], pagination: { hasNextPage: false } } } = await api.get(`/profissionalFaturasMensal/year/${params.year || year}/month/${params.month || month}/situation/${params.situation || situation}/cnpj/${params.cnpj || cnpj}/razaoSocial/${params.razaoSocial || razaoSocial}/tipo/${params.tipo || tipo}?${query.toString()}`);
        setFaturasDetails((prev = []) => (!params?.page ? data.docs : [...prev, ...data.docs]));
        setHasNextPage(data.pagination.hasNextPage);
        setTotalHours(data.totaisHoras);
        setTotalAmount(data.totaisValores);
        setLoading(false);
        setYear(params.year || year);
        setMonth(params.month || month);
        setSituation(params.situation || situation);
        setCnpj(params.cnpj || cnpj);
        setRazaoSocial(params.razaoSocial || razaoSocial);
        setTipo(params.tipo || tipo);
      } catch (error) {
        console.log('🚀 ~ error:', error);
      }
    })();
  }, [page, year, month, situation]);

  const download = useCallback((params = {}) => {
    (async () => {
      try {
        const payload = {
          year: params.year || year,
          month: params.month || month,
          situation: params.situation || situation,
          cnpj: params.cnpj || cnpj,
          razaoSocial: params.razaoSocial || razaoSocial,
          tipo: params.tipo || tipo,
        };

        setLoading(true);
        setLoadingApp({
          loading: true,
          message: 'Aguarde... Gerando PDF.',
        });
        const res = await api.get(`/profissionalFaturasMensal/year/${payload.year}/month/${payload.month}/situation/${payload.situation}/cnpj/${payload.cnpj}/razaoSocial/${payload.razaoSocial}/tipo/${payload.tipo}/downloadPDF`, { responseType: 'blob' });

        const fileName = res.headers['content-disposition']
          .replace('attachment; filename=', '')
          .replace('"', '');

        const fileURL = window.URL.createObjectURL(res.data);
        const alink = document.createElement('a');
        alink.href = fileURL;
        alink.target = '_blank';
        alink.rel = 'noopener noreferrer';
        alink.download = fileName;
        alink.click();

        setLoading(false);
        setLoadingApp(false);
      } catch (error) {
        setLoading(false);
        setLoadingApp(false);
        console.error(error);
      }
    })();
  }, [year, month, situation, cnpj, razaoSocial, tipo, setLoadingApp]);

  return {
    faturasDetails,
    totalHours,
    totalAmount,
    loading,
    hasNextPage,
    page,
    load,
    download,
  };
}

export default useFaturasDetails;
